import React from 'react';
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Select,
  MenuItem,
  TextField,
  IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

function DeliveryTable({
  deliveryRows,
  laydownList,
  partList,
  handleDeliveryRowChange,
  handleDeleteDeliveryRow,
  isEdit
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ maxHeight: 300, overflowY: 'auto', flex: 1 }}
      >
        <Table stickyHeader size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
          <TableHead>
            <TableRow>
              {['Laydown', 'Part Description', 'Part Number', 'Delivered Qty', 'Damaged Qty', 'Actions'].map((label, i) => (
                <TableCell
                  key={label}
                  align={i === 5 ? 'center' : 'left'}
                  sx={{
                    width: i === 5 ? '10%' : i < 3 ? '20%' : '15%',
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {deliveryRows?.map((row, idx) => (
              <TableRow key={idx}>
                {/* Laydown */}
                <TableCell>
                  <Select
                    size="small"
                    fullWidth
                    value={row.laydown}
                    disabled={!isEdit}
                    onChange={(e) => handleDeliveryRowChange(idx, 'laydown', e.target.value)}
                    displayEmpty
                    sx={{ fontSize: '16px' }}
                  >
                    <MenuItem value="" sx={{ fontSize: '16px' }}>Choose a Laydown</MenuItem>
                    {laydownList.map((l) => (
                      <MenuItem key={l.id} value={l.id} sx={{ fontSize: '16px' }}>
                        {l.name}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>

                {/* Part Description */}
                <TableCell>
                  <Select
                    size="small"
                    fullWidth
                    value={row.partDescription || ''}
                    onChange={(e) => handleDeliveryRowChange(idx, 'bom_id', e.target.value)}
                    displayEmpty
                    disabled={!row.laydown || !isEdit}
                    sx={{ fontSize: '16px' }}
                  >
                    <MenuItem value="" sx={{ fontSize: '16px' }}>Select Part Description</MenuItem>
                    {partList.map((opt) => (
                      <MenuItem key={opt.bom_id} value={opt.bom_id} sx={{ fontSize: '16px' }}>
                        {opt.description}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>

                {/* Part Number */}
                <TableCell>
                  <Select
                    size="small"
                    fullWidth
                    value={row.partNumber || ''}
                    onChange={(e) => handleDeliveryRowChange(idx, 'bom_id', e.target.value)}
                    displayEmpty
                    disabled={!row.laydown || !isEdit}
                    sx={{ fontSize: '16px' }}
                  >
                    <MenuItem value="" sx={{ fontSize: '16px' }}>Select Part Number</MenuItem>
                    {partList.map((opt) => (
                      <MenuItem key={opt.bom_id} value={opt.bom_id} sx={{ fontSize: '16px' }}>
                        {opt.part_name}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>

                {/* Delivered Qty */}
                <TableCell>
                  <TextField
                    size="small"
                    type="number"
                    value={row.deliveredQty}
                    onChange={(e) => handleDeliveryRowChange(idx, 'deliveredQty', e.target.value)}
                    inputProps={{ min: 0, style: { fontSize: '16px' } }}
                    fullWidth
                    disabled={!isEdit}
                  />
                </TableCell>

                {/* Damaged Qty */}
                <TableCell>
                  <TextField
                    size="small"
                    type="number"
                    value={row.damagedQty}
                    onChange={(e) => handleDeliveryRowChange(idx, 'damagedQty', e.target.value)}
                    inputProps={{ min: 0, style: { fontSize: '16px' } }}
                    fullWidth
                    disabled={!isEdit}
                  />
                </TableCell>

                {/* Actions */}
                <TableCell align="center">
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleDeleteDeliveryRow(row)}
                    disabled={deliveryRows.length === 1 || !isEdit}
                  >
                    <DeleteIcon sx={{ fontSize: '22px', color: isEdit ? 'red' : "gray" }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default DeliveryTable;
